import React from "react";
import i18n from "../../../constants/i18n";
import getUserAdvancedStore from "../../../stores/user-store/advanced-store";
import { TAlbumItem } from "../../../Types";
import Et3Image from "../../et3-Image";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import PictureAcceptReject from "./PictureAcceptReject";
import Et3Margin from "../../et3-ui/ET3Margin";

export const AlbumItem = withLiteObserverAndTheme<TAlbumItem>((props) => {
  const { theme } = props;
  const { colors } = theme;
  const { picture, index } = props;
  const { id, profilePictureStatus, selfieVerified, isPictureActive, source } =
    getUserAdvancedStore().getImageData(picture);
  const imageSource = getUserAdvancedStore().getImageSource(
    isPictureActive,
    profilePictureStatus
  );
  const borderColor =
    profilePictureStatus === "Y"
      ? colors.all.green
      : profilePictureStatus === "N"
        ? colors.all.red
        : colors.all.gray;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={true}
        width={350}
        height={335}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{ borderRadius: 14 }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={350}
          height={253}
          fDirection="column"
          alignItems="center"
          justifyContent="flex-end"
          color={colors.all.white}
          style={{ position: "relative" }}
          onClick={() => {}}
        >
          <ET3Div
            style={{ position: "relative", display: "flex" }}
            width={204}
            height={204}
            alignItems="flex-end"
            fDirection="column"
            color=""
            justifyContent="flex-end"
            withShadow={false}
            isExtendable={false}
            isScrollable={false}
            onClick={() => {}}
          >
            {selfieVerified === "Y" && (
              <Et3Image
                type="LOCAL"
                alt={i18n.get("USER_ALBUM_PICTURES")}
                imageName={"selfie-verified-badge"}
                size={40}
                onClick={() => {}}
                style={{ left: 0, position: "absolute" }}
              />
            )}
            <Et3Image
              type="ONLINE"
              alt={i18n.get("USER_ALBUM_PICTURES")}
              imageName={source}
              size={204}
              onClick={() => {}}
              style={{
                opacity: isPictureActive ? 1 : 0.5,
                border: `2px solid ${borderColor}`,
                borderRadius: 10,
                alignSelf: "center"
              }}
            />
          </ET3Div>
          <Et3Image
            type="LOCAL"
            alt={i18n.get("USER_ALBUM_PICTURES")}
            imageName={imageSource}
            size={40}
            onClick={() => {}}
            style={{
              position: "absolute"
            }}
          />
        </ET3Div>
        <PictureAcceptReject
          currentImageID={id}
          noImageFound={false}
          currentIndex={index}
        />
      </ET3Div>
      <Et3Margin top={200} bottom={200} left={20} right={20} />
    </React.Fragment>
  );
});
